import { Button, Environment, onEnvironmentChange } from '@hub/shared'
import { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SubscriptionLike } from 'rxjs'
import './cnpj-advantages.component.scoped.scss'

export default () => {
  const [t] = useTranslation('modalContractAccepted')
  const onEnvironmentChangeSubscription = useRef<SubscriptionLike | undefined>(undefined)
  const [urlCreators, setUrlCreators] = useState<string>('')

  useEffect(() => {
    onEnvironmentChangeSubscription.current = onEnvironmentChange.subscribe((environments: Environment) => {
      setUrlCreators(environments?.squidProducts?.creators)
    })
    return () => onEnvironmentChangeSubscription?.current?.unsubscribe()
  }, [])
  return (
    <section className="cnpj-advantages">
      <hr />
      <div className="cnpj-header">
        <div className="display-flex align-items-center justify-content-center">
          <i className="mr-3 2x fa-solid fa-diamond-exclamation" style={{ color: 'var(--gold)' }}></i>
          <h5 className="text-center">{t('cnpjAdvantages.title')}</h5>
        </div>
        <p>{t('cnpjAdvantages.text')}</p>
      </div>
      <div className="cnpj-advantages-card">
        <span className="values">
          <p>
            {t('cnpjAdvantages.grossValue')}
            <strong> RPA</strong>
          </p>
          <p>R$ 2.000*</p>
        </span>
        <span className="values">
          <p>INSS / IRRF / ISS</p>
          <p>R$ 278*</p>
        </span>
        <span className="values">
          <p>
            <strong>{t('cnpjAdvantages.netValue')}</strong>
          </p>
          <p>R$1.722*</p>
        </span>
        <hr style={{ margin: 0, borderStyle: 'dotted' }} />
        <span className="values">
          <p>
            {t('cnpjAdvantages.grossValue')}
            <strong> NF</strong>
          </p>
          <p>R$ 2.000*</p>
        </span>
        <span className="values">
          <p>INSS / IRRF / ISS</p>
          <p>R$ 0*</p>
        </span>
        <span className="values">
          <p>
            <strong>{t('cnpjAdvantages.netValue')}</strong>
          </p>
          <p>R$ 2.000*</p>
        </span>
        <p>
          <strong>{t('cnpjAdvantages.illustrativeValues')}</strong>
        </p>
      </div>
      <div className="display-flex justify-content-center">
        <a href={`${urlCreators}/docs/o-que-e-mais-vantajoso-cnpj-ou-rpa`} target="_blank">
          <Button
            id="cnpj-advantages-redirect"
            size="sm"
            color="transparent"
            textColor="var(--primary_color)"
            borderColor="var(--primary_color)"
          >
            <span>
              <i className="mr-2 fa-solid fa-up-right-from-square" style={{ color: 'var(--primary_color)' }}></i>
              {t('cnpjAdvantages.button')}
            </span>
          </Button>
        </a>
      </div>
    </section>
  )
}
